import { useMutation } from "@tanstack/react-query";
import { CreateComment } from "../types/Comment";
import { createComment } from "./comments.service";

export const useCreateComment = () => {
  return useMutation({
    mutationFn: (comment: CreateComment) => createComment(comment),
  });
};
